import React from "react";
import {
  Checkbox,
  Chip,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
  Badge,
} from "@heroui/react";
import { RelationSetType, type RelationItem } from "./relationship.d";
import { Plus, X } from "lucide-react";
import { Trans } from "@lingui/react/macro";

const RelationItemSelector = ({
  items,
  onChange,
  selectedItems,
}: {
  items: RelationItem[];
  onChange: (selectedItems: RelationSetType["items"]) => void;
  selectedItems: RelationSetType["items"];
}) => {
  const handleGroupToggle = (id: number) => {
    const isSelected = selectedItems.includes(id);

    if (isSelected) {
      onChange(selectedItems.filter((g) => g !== id));
    } else {
      onChange([...selectedItems, id]);
    }
  };

  const availableUnselectedGroups = items.filter(
    (item) => !selectedItems.includes(item.id),
  );

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <p className="text-small text-default-500">
          <Trans>Izbrane skupine sredstev:</Trans>
        </p>
        <Dropdown>
          <DropdownTrigger>
            <Button
              variant="flat"
              size="sm"
              startContent={<Plus />}
              isDisabled={availableUnselectedGroups.length === 0}
            >
              <Trans>Dodaj skupino sredstev</Trans>
            </Button>
          </DropdownTrigger>
          <DropdownMenu aria-label="Available Resource Groups">
            {availableUnselectedGroups.length > 0 ? (
              availableUnselectedGroups.map((group) => (
                <DropdownItem
                  key={group.id}
                  description={group.description}
                  onPress={() => handleGroupToggle(group.id)}
                >
                  {group.name}
                </DropdownItem>
              ))
            ) : (
              <DropdownItem key="no-more-groups" isDisabled>
                <Trans>Ni več skupin sredstev</Trans>
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
      <div className="flex flex-wrap gap-2">
        {selectedItems.length > 0 ? (
          selectedItems.map((id) => {
            const item = items.find((item) => item.id === id)!;

            return (
              <Chip
                key={item.id}
                variant="solid"
                color="primary"
                className="cursor-pointer"
                onClose={() => handleGroupToggle(item.id)}
                endContent={<X className="text-xs" />}
              >
                {item.name}
              </Chip>
            );
          })
        ) : (
          <p className="text-small italic text-default-400">
            <Trans>Ni izbranih skupin sredstev</Trans>
          </p>
        )}
      </div>
    </div>
  );
};

export default RelationItemSelector;
